import React from "react";
import { useAccountCustomer } from "../../../api/hooks/useAccountCustomer";
import { useCrumb } from "../useCrumb";

export const CustomerNameCrumb: React.FC<{
  match: {
    params: { accountNumber: string };
  };
}> = ({ match }) => {
  const { data: customer, isError } = useAccountCustomer(
    match.params.accountNumber,
    {
      refetchOnWindowFocus: false,
    },
  );
  const crumb = useCrumb({ label: customer?.name });

  if (isError) {
    // If the Customer API lookup timesout or fails, we remove the "slot" from
    // the breadcrumb explicitly so the skeleton loader isn't showing forever.
    crumb.current?.remove();
  }

  return null;
};
